import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/docs/basics/BasicsPage.tsx");
